import React from 'react';
import { AlertCircle, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}
export function ErrorMessage({
  message,
  onRetry
}: ErrorMessageProps) {
  // Check if the message is about CORS proxy activation
  const isCorsProxyError = message.includes('CORS Proxy requires activation') || message.includes('corsdemo');
  const handleActivateCorsProxy = () => {
    window.open('https://cors-anywhere.herokuapp.com/corsdemo', '_blank');
  };
  return <Card className="border-destructive/20 bg-destructive/5" data-id="element-1504">
      <CardContent className="p-6 text-center" data-id="element-1505">
        <AlertCircle size={48} className="mx-auto text-destructive mb-4" data-id="element-1506" />
        <h3 className="text-lg font-medium mb-2" data-id="element-1507">Error Loading Data</h3>
        {isCorsProxyError ? <>
            <p className="text-muted-foreground mb-4" data-id="element-1508">
              The CORS proxy service requires temporary activation before it can
              be used.
            </p>
            <div className="flex flex-col gap-3 items-center" data-id="element-1509">
              <Button onClick={handleActivateCorsProxy} className="flex items-center" data-id="element-1510">
                <ExternalLink size={16} className="mr-2" data-id="element-1511" />
                Activate CORS Proxy
              </Button>
              <p className="text-sm text-muted-foreground" data-id="element-1512">
                After activation, come back here and click retry
              </p>
              {onRetry && <Button onClick={onRetry} variant="outline" className="mt-2" data-id="element-1513">
                  Retry
                </Button>}
            </div>
          </> : <>
            <p className="text-muted-foreground mb-4" data-id="element-1514">{message}</p>
            {onRetry && <Button onClick={onRetry} data-id="element-1515">Try Again</Button>}
          </>}
      </CardContent>
    </Card>;
}